import React, { useState } from "react";
import { capabilities } from "../mock";
import { Check, ArrowRight } from "lucide-react";

const Capabilities = () => {
  const [active, setActive] = useState(capabilities[0].key);
  const current = capabilities.find((c) => c.key === active);

  return (
    <section id="capabilities" className="py-24 bg-[#0B1B3B] text-white relative overflow-hidden">
      <div className="absolute inset-0 grid-lines-bg opacity-40" />
      <div className="absolute -top-40 right-0 w-[500px] h-[500px] rounded-full orb"
           style={{ background: "radial-gradient(closest-side, rgba(30,86,227,0.25), transparent 70%)" }} />

      <div className="container-x relative">
        <div className="max-w-3xl reveal">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#7CA6FF] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full">
            Capabilities
          </span>
          <h2 className="mt-4 text-3xl md:text-[42px] font-bold leading-tight">
            Our best data engineering services <br className="hidden md:block" /> and capabilities
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-10">
          {/* Tabs */}
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-1">
              {capabilities.map((c) => (
                <button
                  key={c.key}
                  onClick={() => setActive(c.key)}
                  className={`relative text-left px-5 py-4 rounded-lg border transition-all ${
                    active === c.key
                      ? "bg-white/10 border-white/20 text-white"
                      : "bg-transparent border-white/5 text-slate-400 hover:text-white hover:bg-white/5"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-[13px] font-semibold tracking-wider uppercase">{c.tab}</span>
                    {active === c.key && <ArrowRight size={16} className="text-[#7CA6FF]" />}
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-8">
            <div key={active} className="reveal visible bg-gradient-to-br from-white/[0.06] to-white/[0.02] border border-white/10 rounded-2xl p-8 md:p-10">
              <h3 className="text-2xl md:text-3xl font-bold leading-snug">{current.title}</h3>
              <ul className="mt-6 space-y-4">
                {current.points.map((p, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="mt-1 h-6 w-6 rounded-full bg-[#1E56E3]/20 border border-[#1E56E3]/40 flex items-center justify-center shrink-0">
                      <Check size={13} className="text-[#7CA6FF]" />
                    </span>
                    <span className="text-[15px] text-slate-200 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
              <a href="#contact" className="btn-primary mt-8">Know More <ArrowRight size={16} /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
